import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import OrderTable from './OrderTable';

const Orders = () => {
  return (
    <React.Fragment>
      <div className="page-content p-0">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <OrderTable />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Orders;
